export default __webpack_public_path__ + "static/media/bitcash_icon.6ac7a97a.png";